(function () {
  function initOwnerReviews(root) {
    const section = root.matches('.owner-reviews') ? root : root.querySelector('.owner-reviews');
    if (!section) return;

    const swiperEl = section.querySelector('.owner-reviews__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    new Swiper(swiperEl, {
      slidesPerView: 1.15,
      spaceBetween: 14,
      speed: 500,
      grabCursor: true,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 18,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 22,
        },
      },
      navigation: {
        nextEl: section.querySelector('.owner-reviews__next'),
        prevEl: section.querySelector('.owner-reviews__prev'),
      },
    });
  }

  function initAll() {
    document.querySelectorAll('.owner-reviews').forEach(initOwnerReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initOwnerReviews(event.target);
  });
})();
